import { useLocation } from '@reach/router';
import { Helmet } from 'react-helmet-async';

import { type ArticleType } from '@xing-com/crate-articles-article-editor';
import { useHost } from '@xing-com/crate-xinglet';

type ArticleHelmetProps = {
  article: ArticleType;
  skip: boolean;
};

const ArticleHelmet: React.FC<ArticleHelmetProps> = ({ article, skip }) => {
  const { pathname } = useLocation();
  const { getHostname } = useHost();

  if (skip) {
    return null;
  }

  const articleSEOSettings = article.settings;

  const metaTitle = `${articleSEOSettings?.titleTag || article.headline} | XING`;
  const metaDescription =
    articleSEOSettings?.descriptionTag || article.subtitle || '';
  const metaImage = article.headerImageURL || '';

  return (
    <Helmet>
      <title>{metaTitle}</title>
      <meta name="description" content={metaDescription} />

      {/* Twitter */}
      <meta name="twitter:title" content={metaTitle} />
      <meta name="twitter:description" content={metaDescription} />
      <meta name="twitter:image" content={metaImage} />

      {/* OG tags */}
      <meta property="og:title" content={metaTitle} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:image" content={metaImage} />

      <link rel="canonical" href={`https://${getHostname()}${pathname}`} />
    </Helmet>
  );
};

export default ArticleHelmet;
